var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title1"},[_vm._t("default"),_c('div',{staticClass:"title1-line"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }